<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <div class="navbar-brand">Company Management</div>
    <div>
        <a class="btn btn-sm btn-outline-primary ms-auto" [routerLink]="['/lo/admin/company/form']">&#43; Add Company</a>
    </div>
  </div>
</nav>
<hr/>
<app-table #table ></app-table>
